import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';

/**
 * Route wrapper that redirects unauthenticated users to the custom login page.
 *
 * While the auth check is in progress a loading indicator is shown.
 * Once resolved, authenticated users see the child routes; unauthenticated
 * users are redirected to /login.
 */
export function ProtectedRoute() {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-gray-500">Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
